import React from 'react';

import { useHawksearch } from 'components/StoreProvider';
import ReactDOM from 'react-dom';
import { isLet } from '@babel/types';

function ViewSelector() {
	const {
		store: { searchResults, pendingSearch },
		actor,
	} = useHawksearch();
	const tabFacet = searchResults && searchResults.Facets.find(facet => facet.FieldType === 'tab');
	const selectedTabFacetValue = tabFacet && tabFacet.Values.find(value => value.Selected === true);
	const component = document.getElementById('react-app');
	const dataDisplayMode = component && component.getAttribute('data-display-mode');
	const element = document.getElementsByClassName('hawk-results__listing');
	return (
		<div
			className="hawk-viewselector__controls"
			style={{
				display:
					(selectedTabFacetValue && selectedTabFacetValue.Label === 'Content') || dataDisplayMode === 'none'
						? 'none'
						: 'block',
			}}
		>
			<span
				onClick={() => {
					if (element) {
						element[0].classList.remove('list');
						element[0].classList.add('grid');
						if (component) {
							component.setAttribute('data-display-mode', 'grid');
						}
					}
				}}
				className="listing-display-option link-icon active"
				ddm-selection="grid"
			>
				<span className="display-icon-grid" />
			</span>
			&nbsp;
			<span
				onClick={() => {
					if (element) {
						element[0].classList.remove('grid');
						element[0].classList.add('list');
						if (component) {
							component.setAttribute('data-display-mode', 'list');
						}
					}
				}}
				className="listing-display-option link-icon"
				ddm-selection="list"
			>
				<span className="display-icon-list" />
			</span>
		</div>
	);
}

export default ViewSelector;
